import { GalleryConfig } from 'rangeConfig/@types';

const jonaxelGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-09297657' },
        { id: 'SPR-79305102' },
        { id: 'SPR-89297677' },
        { id: 'SPR-39323990' },
        { id: 'SPR-49297660' },
        { id: 'SPR-59317554' },
        { id: 'SPR-99297686' },
        { id: 'SPR-89297663' },
        { id: 'SPR-09306204' },
        { id: 'SPR-89311466' },
        { id: 'SPR-59311463' },
        { id: 'SPR-29308645' }
      ]
    }
  ]
};

export default jonaxelGalleryConfig;
